import { FC, memo, useCallback, useEffect, useMemo, useState } from "react";
import * as React from "react";

import { DropdownList } from "@livechat/design-system";

import { ICannedResponsesProps } from "components/message-box/canned-responses";
import { KeyCodeEnum } from "constants/keyCode";
import { createNewEvent } from "helpers/events";

import { CannedResponseItem } from "./CannedResponseItem";
import { CannedResponsesDropdown } from "./CannedResponsesDropdown";
import { CannedResponsesTagList } from "./CannedResponsesTagList";
import { dropdownListStyles } from "./styles";

const cannedSelectKeyCodes = [KeyCodeEnum.ArrowRight, KeyCodeEnum.Enter];

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
export const CannedResponses: FC<ICannedResponsesProps> = memo(
  ({
    className,
    items,
    onClose,
    onSearchResultsCountChange,
    onSelect,
    searchPhrase,
    textareaWithCannedResponsesRef,
  }) => {
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    const [selectedTag, selectTag] = useState<string>(null);
    const areCannedResponsesVisible = !!selectedTag;

    const handleResponseSelect = useCallback(
      (response: string, event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
        // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
        selectTag(null);
        // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
        onSelect(response, event.type === "keydown" ? "keyboard" : "mouse");

        // trigger custom event for chat tutorial
        const cannedCustomEvent = createNewEvent("canned_response_used");
        document.dispatchEvent(cannedCustomEvent);
      },
      [onSelect]
    );

    const handleClose = useCallback(() => {
      // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      selectTag(null);
      onClose();
    }, [onClose]);

    const handleKeydown = useCallback(
      (e: KeyboardEvent) => {
        if (areCannedResponsesVisible && e.keyCode === KeyCodeEnum.ArrowLeft) {
          e.preventDefault();
          // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
          selectTag(null);
        }
      },
      [areCannedResponsesVisible]
    );

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleLeftArrowClick = (e: React.MouseEvent<HTMLDivElement>) => {
      // Prevent click outside
      e.nativeEvent.stopImmediatePropagation();
      // Prevent onSelect
      e.stopPropagation();
      // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      selectTag(null);
    };

    const handleSearchResultsCountChange = useCallback(
      (count: number) => {
        if (onSearchResultsCountChange) {
          onSearchResultsCountChange(count);
        }

        if (count === 0) {
          // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
          selectTag(null);

          /*
           We want to reopen canned responses as in case of no results
           They're not visibile and user might want to search again.
           Fully close canneds only when there is no results and user used space as last search phrase symbol
          */
          if (searchPhrase.endsWith(" ")) {
            onClose();
          }
        }
      },
      [onSearchResultsCountChange, onClose, searchPhrase]
    );

    const cannedItems = useMemo(
      () =>
        areCannedResponsesVisible
          ? // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            items
              .find(item => item.name === selectedTag)
              .values.map((item, index) => ({
                itemId: item.id,
                content: (
                  <CannedResponseItem
                    name={item.text}
                    onArrowClick={handleLeftArrowClick}
                    testSelector={`canned-response-item-${index}`}
                  />
                ),
                onItemSelect: handleResponseSelect,
              }))
          : [],
      [areCannedResponsesVisible, items, handleResponseSelect, selectedTag]
    );

    useEffect(() => {
      document.addEventListener("keydown", handleKeydown);

      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      return () => {
        document.removeEventListener("keydown", handleKeydown);
      };
    }, [handleKeydown]);

    return (
      <CannedResponsesDropdown
        className={className}
        onClose={handleClose}
        textareaWithCannedResponsesRef={textareaWithCannedResponsesRef}
      >
        <CannedResponsesTagList
          tags={items}
          searchPhrase={searchPhrase}
          isVisible={!areCannedResponsesVisible}
          onClose={onClose}
          onSearchResultsCountChange={handleSearchResultsCountChange}
          onSelect={selectTag}
        />
        {areCannedResponsesVisible && (
          <DropdownList
            css={dropdownListStyles()}
            autoFocusOnItemsCountChange
            itemSelectKeyCodes={cannedSelectKeyCodes}
            // @ts-expect-error TS(2322)
            items={cannedItems}
          />
        )}
      </CannedResponsesDropdown>
    );
  }
);
